import { EProjectStatus } from '@/models/dtos/enums/eProjectStatus'
import { TemplateDto } from '@/models/dtos/templateDto'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class ProjectMixin extends Vue {
  isActive(status: EProjectStatus) {
    return status === EProjectStatus.Started
  }

  getStatusBadgeClass(status: EProjectStatus) {
    return this.isActive(status) ? 'success' : 'danger'
  }

  statusName(status: EProjectStatus) {
    let statusName = ''

    switch (status) {
      case EProjectStatus.Started:
        statusName = 'Aktywny'
        break
      case EProjectStatus.Completed:
        statusName = 'Zakończony'
        break
      case EProjectStatus.Closed:
        statusName = 'Zamkniety'
        break
      default:
        statusName = 'Aktywny'
    }

    return statusName
  }

  getTemplateById(id: string, templates: TemplateDto[]): TemplateDto | undefined {
    const template = templates!.find(t => t.id === id)

    return template
  }
}
